module.exports = __webpack_public_path__ + "static/26-COSTA-RICA-AGUADULCE.6bdb6944.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/beverages/26-COSTA-RICA-AGUADULCE.png
// module id = 624
// module chunks = 35783957827783